<template>
  <v-app class="app-main">
    <mobile-app-bar v-if="showMobileAppBar" @show="showBar = !showBar" />
    <navigation-drawer
      v-if="showNavigationDrawer"
      :mobile="isMobile"
      :show="showBar"
      @hide="showBar = false"
    />
    <default-app-bar v-if="showDefaultAppBar" />
    <v-main>
      <router-view v-slot="{ Component, route }">
        <transition name="slide-fade" mode="out-in">
          <component :is="Component" :key="route.path" v-if="Component" />
        </transition>
      </router-view>
    </v-main>
  </v-app>
</template>
<script>
import MobileAppBar from "@/components/dashboard/MobileAppBar.vue";
import NavigationDrawer from "@/components/dashboard/NavigationDrawer.vue";
import DefaultAppBar from "@/components/dashboard/DefaultAppBar.vue";
export default {
  name: "App",
  components: { MobileAppBar, NavigationDrawer, DefaultAppBar },
  data: () => ({
    showBar: false
  }),
  mounted() {
    this.$store.dispatch("loadLocalStorage");
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      this.$store.commit("setCurrentLayout", this.layoutManager);
    }
  },
  computed: {
    layoutManager() {
      const width = this.$vuetify.display.width;
      const height = this.$vuetify.display.height;
      switch (true) {
        case width <= 600:
          return "mobile_portrait";
        case width <= 1024 && height <= 600:
          return "mobile_landscape";
        case width <= 1280 && height < width:
          return "tablet_landscape";
        case width <= 1280 && height > width:
          return "tablet_portrait";
        default:
          return "desktop";
      }
    },
    isMobile() {
      return this.layoutManager.includes("mobile");
    },
    showMobileAppBar() {
      if (this.isLoading) return false;

      return (
        this.$route.name !== "Login" &&
        this.$route.name !== undefined &&
        this.$route.name !== "SCMaxx" &&
        this.isMobile
      );
    },
    showNavigationDrawer() {
      if (this.isLoading) return false;

      return (
        this.$route.name !== "Login" &&
        this.$route.name !== undefined &&
        this.$route.name !== "SCMaxx"
      );
    },
    showDefaultAppBar() {
      if (this.isLoading) return false;

      return this.$route.name !== "Login" || this.$route.name === undefined;
    },
    colors() {
      return this.$vuetify.theme.global.current.colors;
    },
    baseColor() {
      return this.colors.primary;
    },
    isLoading() {
      return this.$store.getters.isLoadingStores;
    }
  }
};
</script>
<style>
#app {
  font-optical-sizing: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

body {
  font-optical-sizing: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  -webkit-background-clip: text;
}

::-webkit-scrollbar {
  width: 0.5rem;
}

::-webkit-scrollbar-thumb {
  background-color: #3acbc7;
  border-radius: 2rem;
}

::-webkit-scrollbar-track {
  background: transparent;
}

.slide-fade-enter-active {
  transition: all 0.5s ease-in;
}

.slide-fade-leave-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}
</style>
